module.exports = __webpack_public_path__ + "assets/AppStoreBadgeWhite_RU.13ab67081c7febc7735feefd3f17ba20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/AppStoreBadgeWhite_RU.svg
// module id = 181
// module chunks = 0